export default __webpack_public_path__ + "static/media/city-hall-official-journal.d05ac432.svg";